/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2020-12-25 19:23:58
 * Copyright © Leedarson. All rights reserved.
 */

const _modal = {};
let _currentSequenceId = '';

export const createModalSequence = (sequenceId, { close, lock }) => {
  _currentSequenceId = sequenceId;
  _modal[sequenceId] = {
    close,
    lock,
  };
};

export const removeModalSequence = sequenceId => {
  const id = sequenceId || _currentSequenceId;
  delete _modal[id];
};

export const destroyModal = (sequenceId, alwayDestroy) => {
  const id = sequenceId || _currentSequenceId;
  const modal = _modal[id];
  if (modal) {
    if (!modal.lock || alwayDestroy) {
      modal.close();
    }
  }
};

export const getModalSequenceLength = () => {
  return Object.keys(_modal).length;
};
